import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router} from '@angular/router';
import {Observable, of} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {select, Store} from '@ngrx/store';
import {AppState} from '../../reducers';
import {currentUser} from '../../selectors/auth.selectors';
import {USER_STATUS_NOT_CONFIRMED} from '../../models/user.model';
import { SPACE_TYPE_SUUMO } from '../../models/space.model';

@Injectable()
export class StatusGuard implements CanActivate {
    constructor(private store: Store<AppState>, private router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean>  {
        const path = route.url[0].path;
        if (path === '/auth/change-password') {
            return of(true);
        }
        return this.store.pipe(select(currentUser),
            map((user): [boolean, number] => {
                if (user) {
                    if (user.status === USER_STATUS_NOT_CONFIRMED) {
                        return [false, user.spaceType];
                    }
                    return [true, user.spaceType];
                }
                return [true, 0];
            }),
            tap(data => {
                const hasAccess = data[0];
                if (!hasAccess) {
                    const spaceType = data[1];
                    if (spaceType === SPACE_TYPE_SUUMO) {
                        this.router.navigateByUrl('/auth/change-password?loginType=suumo');
                    } else {
                        this.router.navigateByUrl('/auth/change-password');
                    }
                }
            }),
            map(data => data[0])
        );
    }
}
